import mixitup from 'mixitup';

if ($('.filter-toggles').length > 0) {
	let filterList = $('.filter-list');
	let filterToggles = $('.filter-toggles');

	filterList.on('click', '.filter', function (event) {
		event.preventDefault();
		filterToggles.find('.filter').removeClass('active');
		filterToggles.find('.filter[data-toggle="all"]').addClass('active');
	});

	let firstAcriveFilter = filterList.find('.filter').first().attr('data-filter');

	let filteringToggles = mixitup('.filter-toggles', {
		selectors: {
			target: '.filter'
		},
		load: {
			filter: firstAcriveFilter
		}
	});
}
